import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {ErrorType} from "config/errors";

import {ErrorPayload, supportWebformApi} from "webform/api";

import {SupportContactFormService} from "webform/gen/supportContactForm";

export const getUserPersonasList = createAsyncThunk(
    "webform/userPersona/getUserPersonasList",
    async (req: SupportContactFormService.UserPersonasListRequest, {rejectWithValue}) => {
        try {
            return {response: await supportWebformApi.userPersonasList(req), locale: req.locale};
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

interface UserPersonaState {
    userPersonas: SupportContactFormService.UserPersonaData[] | null;
    error?: ErrorType;
    isLoading: boolean;
    responseLocale?: string;
}

export const initialState: UserPersonaState = {
    userPersonas: null,
    isLoading: false,
};

export const slice = createSlice({
    name: "userPersona",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUserPersonasList.fulfilled, (state, action) => {
            state.responseLocale = action.payload.locale;
            state.userPersonas = action.payload.response.user_personas;
            state.isLoading = false;
            if (!action.payload.response.user_personas.length) {
                state.error = ErrorType.USER_PERSONA_FETCH_FAILED;
            } else {
                state.error = undefined;
            }
        });
        builder.addCase(getUserPersonasList.rejected, (state, action) => {
            const typedPayload = action.payload as ErrorPayload;

            if (typedPayload.response?.error_data?.expiredAt) {
                state.error = ErrorType.TOKEN_EXPIRED;
            } else {
                state.error = ErrorType.USER_PERSONA_FETCH_FAILED;
            }
            state.isLoading = false;
        });
        builder.addCase(getUserPersonasList.pending, (state) => {
            state.userPersonas = null;
            state.error = undefined;
            state.isLoading = true;
        });
    },
});

export default slice.reducer;
